import React from "react";
import { IconButton } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import StopCircleIcon from "@mui/icons-material/StopCircle";

const SendStopButtons = ({ isStreaming, handleSendClick, handleStreaming }) => {
    return (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {!isStreaming ? (
                <IconButton
                    onClick={handleSendClick}
                    sx={{
                        backgroundColor: "#333366",
                        color: "#FFFFFF",
                        "&:hover": { backgroundColor: "#222244" },
                        transition: "all 0.3s ease",
                    }}
                >
                    <SendIcon />
                </IconButton>
            ) : (
                <IconButton
                    onClick={handleStreaming}
                    sx={{
                        backgroundColor: "#EF4444",
                        color: "#FFFFFF",
                        "&:hover": { backgroundColor: "#DC2626" },
                        transition: "all 0.3s ease",
                    }}
                >
                    <StopCircleIcon />
                </IconButton>
            )}
        </div>
    );
};

export default SendStopButtons;
